import React from 'react';
import styled, { css } from 'styled-components';
import { ColorPalettes, Breakpoints, Portal } from 'kinedu-react-components';
import { Button } from 'lego-dist';

const { KineduPalette } = ColorPalettes;

const StyledNotificationBanner = styled.div < any > `
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  margin: auto;
  padding: 6px 15px;
  box-sizing: border-box;

  background-color: ${KineduPalette.physical};
  font-size: 10px;
  z-index: 10000;

  ${Breakpoints.tablet} {
    position: relative;
    flex-direction: row;
  }

  ${({ color }) => color && css`
    background-color: ${color};
  `}

  ${({ show }) => (show
    ? css`display: flex; `
    : css`display: none;`
  )}

  .bannerButton {
    flex-shrink: 0;
    min-height: 0;
    height: 25px;
    padding: 0px 20px;
  }
`;


const Message = styled.span`
  color: white;
  font-size: 16px;
  margin: 0;

  ${Breakpoints.desktop} {
    margin: auto 20px;
  }
`;

interface NotificationBannerProps {
  className?: string,
  show?: boolean,
  message: string,
  buttonMessage?: string,
  buttonCallback?: any,
  color?: string,
}

const NotificationBanner: React.FC<NotificationBannerProps> = ({
  show,
  className,
  color,
  buttonCallback,
  buttonMessage,
  message,
}) => (
  <Portal rootId="root" insertBefore>
    <StyledNotificationBanner show={show} className={className} color={color}>
      <Message>
        {message}
      </Message>
      {buttonMessage ? (
        <Button
          onClick={() => buttonCallback()}
          className="bannerButton"
          maxWidth={150}
          outline
          color="white"
          rounded
        >
          {buttonMessage}
        </Button>
      ) : null}
    </StyledNotificationBanner>
  </Portal>
);

export default NotificationBanner;
